module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"uploadFile":"JSON-Datei auswählen:","pendingMessage":"Portfolio wird importiert, dieser Vorgang kann mehrere Minuten dauern. Sie werden zum neuen Portfolio weitergeleitet, sobald der Vorgang abgeschlossen ist."}}')
  delete Component.options._Ctor
}
